import { Controller } from "stimulus"
import morphdom from 'morphdom';


class TableSponsorPublisherRowController extends Controller {
  tableIdentifier = "m-table";
  tableApiIdentifier = "t";

  initialize() {
    if(this.element.dataset['tableIdentifier']) {
      this.tableIdentifier = this.element.dataset['tableIdentifier'];
    }

    if(this.element.dataset['tableApiIdentifier']) {
      this.tableApiIdentifier = this.element.dataset['tableApiIdentifier'];
    }

    this.noRender = this.element.getAttribute('data-no-render');
  }

  connect() {
    // const placeholderDom = this.element.closest(`.${this.tableIdentifier}`).querySelector(`.${this.tableIdentifier}-sponsored-publisher-placeholder`);
    const adContainer = this.element.closest('[data-controller*="ad-position"]');
    adContainer.classList.add('t-hidden');

    const nextElement = adContainer.nextElementSibling;
    if (nextElement && nextElement.classList.contains('content-sponsored-row')) {
      nextElement.remove();
    }

    this.element.classList.add(`${this.tableIdentifier}-sponsored-publisher-placeholder`);
    this.element.classList.add('content-sponsored-row');
    this.element.dataset.controller = '';
    if (this.noRender == 'true') {
      this.element.classList.add('t-hidden');
    }

    adContainer.insertAdjacentElement('afterend', this.element);
    // morphdom(placeholderDom, this.element);
  }

}

export default TableSponsorPublisherRowController;
